import { Component } from 'react';
import { Box, Button } from "@mui/material";
const Constants = require("../constants/Constants");

class ShowScoresButton extends Component {

    constructor(props) {
        super(props);
        this.state = {
            value: ""
        }
        this.id = props.id

    }

    render() {

        let IMAGE_URL = Constants.IMAGE_URL
        return (
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{ p: 1 }}>
                <Button
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2, maxWidth: "200px", backgroundColor: "primary.dark", border: 2, boxShadow: 6, borderColor: 'black' }}
                    onClick={(event) => this.props.handleShowScores(event)}
                >
                    <img loading="lazy" src={`${IMAGE_URL}navigation/ShowScores.png`} style={{ width: "90%" }} alt="Retire Button" />
                </Button>

            </Box>
        )
    }
}

    export default ShowScoresButton
